import(/* webpackMode: "eager" */ "/app/apps/web/app/[locale]/support/page.tsx");
